// @flow

import { graphql } from 'react-relay';
import createRelayMutation from 'shared/gql/createRelayMutation';

const mutation = graphql`
  mutation UpdateWarehouseLocationMutation(
    $input: UpdateWarehouseLocationInput!
  ) {
    updateWarehouseLocation(input: $input) {
      warehouseLocationEdge {
        cursor
        node {
          id
          name
          code
          description
          isActive
          updatedAt
          createdAt
        }
      }
    }
  }
`;

export default {
  commit: (options: *) => {
    return createRelayMutation(mutation, {
      ...options,
    });
  },
};
